import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["label"];

  connect() {
    if (Cookies.get("hidePortfolioNewLabel") === undefined) {
      this._showLabel();
    }
  }

  hideLabel() {
    Cookies.set("hidePortfolioNewLabel", true, { expires: 365, path: "/" });
    this.labelTarget.classList.add("tw-hidden");
  }

  _showLabel() {
    this.labelTarget.classList.remove("tw-hidden");
  }
}
